import axios, { AxiosInstance } from 'axios';
import { apiSGIGOURL, mockAndDevelopment } from '../../app.config';

const sgigoClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiSGIGOURL(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default sgigoClient;
